import React from 'react';
import styled from 'styled-components';
import Button, {
  ButtonProps,
} from '@grnhse/seedling/lib/azalea/components/button';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-s3-uploader'. 'node_modules/react-s3-uploader/index.js' implicitly has an 'any' type.
import ReactS3Uploader from 'react-s3-uploader';
import uuid from 'uuid';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'rc-progress'. 'node_modules/rc-progress/lib/index.js' implicitly has an 'any' type.
import { Line } from 'rc-progress';
import EditableRow from 'shared/components/drag-drop/EditableRow';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/utils/button'. 'app/webpack/javascripts/shared/utils/button.js' implicitly has an 'any' type.
import { clickOnKeyUp } from 'shared/utils/button';

import { showResponseFlashMessages, Response } from 'shared/utils/request';
import { FileIcon, PaperclipIcon } from '@grnhse/seedling/lib/azalea/icons';
import { clearFix } from 'polished';
import { withLocalePrefix } from 'shared/utils/translation';
import { RequestError } from 'shared/utils/request';

const t = withLocalePrefix('uploads');

const MIN_UPLOAD_DURATION = 1000;

// Helpers
const noop = () => {};
const getErrorResponse: (message: string) => Response<null> = (message) => {
  return {
    name: '',
    message,
    response: {
      status: 400,
      statusText: '',
      data: { message },
    },
    data: null,
    status: 400,
    statusText: '',
    headers: null,
    config: {},
  } as unknown as RequestError & Response<null>;
};

const updateFile = (
  uploads: any,
  file: FileWithStart,
  update: {
    progress: number;
  }
) =>
  // @ts-expect-error - TS7006 - Parameter 'upload' implicitly has an 'any' type.
  uploads.map((upload) =>
    upload.file.name === file.name ? { ...upload, ...update } : upload
  );

type FileWithStart = File & {
  startTime: number;
};

type Upload = {
  file: FileWithStart;
  key: string;
  progress?: number;
  inProgress?: boolean;
};

type Props = {
  // @ts-expect-error - TS2339 - Property 'ReactChildren' does not exist on type 'typeof React'.
  children?: typeof React.ReactChildren;
  id: string;
  maxSize: number;
  onChange: (arg1?: any) => any;
  onFileRejected: (arg1: File, arg2: string) => any;
  onFileFinished: (arg1: Upload) => any;
  onFileRemoved: (arg1: Upload) => any;
  acceptedMimeTypes: Array<string>;
  acceptedExtensions: Array<string>;
  showFlashErrors: boolean;
  multiple: boolean;
  autoUpload: boolean;
  signingUrl?: string;
  disabled: boolean;
};

export const RejectionReason = {
  MAX_SIZE_EXCEEDED: 'errors.too_large',
  TYPE_NOT_ALLOWED: 'errors.invalid_file_type',
  FILE_NAME_CONFLICT: 'errors.file_name_conflict',
} as const;

export default class S3Uploader extends React.Component<Props, any> {
  static defaultProps = {
    id: uuid.v4(),
    maxSize: 1000 * 1000 * 250, // 250mb
    onChange: noop,
    onFileRejected: noop,
    onFileFinished: noop,
    onFileRemoved: noop,
    acceptedMimeTypes: [],
    acceptedExtensions: [],
    showFlashErrors: true,
    multiple: false,
    autoUpload: true,
    disabled: false,
  };

  state = {
    uploads: [],
    removedUploads: [],
  };

  uploadInput: {
    value: any;
  } = { value: null };

  formatFileSize = (sizeInBytes: number) =>
    `${Math.trunc(sizeInBytes / 1000 / 1000)}MB`;

  preprocess = (file: File, next: any) => {
    const { maxSize, acceptedMimeTypes, acceptedExtensions, onFileRejected } =
      this.props;
    let rejection = null;

    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const fileExtension = `.${file.name.split('.').pop().toLowerCase()}`;
    const isMimeTypeAccepted =
      acceptedMimeTypes.length === 0 || acceptedMimeTypes.includes(file.type);
    const isExtensionAccepted =
      acceptedExtensions.length === 0 ||
      acceptedExtensions.includes(fileExtension);

    if (file.size > maxSize) {
      rejection = {
        reason: RejectionReason.MAX_SIZE_EXCEEDED,
        options: {
          file_name: file.name,
          max_size: this.formatFileSize(maxSize),
        },
      };
    } else if (!isMimeTypeAccepted || !isExtensionAccepted) {
      rejection = {
        reason: RejectionReason.TYPE_NOT_ALLOWED,
        options: { extension: fileExtension },
      };
      // @ts-expect-error - TS2339 - Property 'file' does not exist on type 'never'.
    } else if (this.state.uploads.some((u) => u.file.name === file.name)) {
      rejection = {
        reason: RejectionReason.FILE_NAME_CONFLICT,
        options: null,
      };
    }

    if (rejection) {
      this.props.showFlashErrors &&
        showResponseFlashMessages(
          getErrorResponse(t(rejection.reason, rejection.options || {}))
        );
      onFileRejected(file, rejection.reason);
      this.clearInput();
      return;
    }

    const matchingRemovedUpload = this.state.removedUploads.find(
      // @ts-expect-error - TS2339 - Property 'file' does not exist on type 'never'.
      (upload) => upload.file.name === file.name
    );

    if (matchingRemovedUpload) {
      // @ts-expect-error - TS7031 - Binding element 'uploads' implicitly has an 'any' type. | TS7031 - Binding element 'removedUploads' implicitly has an 'any' type.
      this.setState(({ uploads, removedUploads }) => ({
        uploads: [...uploads, matchingRemovedUpload],
        removedUploads: removedUploads.filter(
          // @ts-expect-error - TS7006 - Parameter 'ru' implicitly has an 'any' type. | TS2339 - Property 'key' does not exist on type 'never'.
          (ru) => ru.key !== matchingRemovedUpload.key
        ),
      }));
    } else {
      next(file);

      // @ts-expect-error - TS7031 - Binding element 'uploads' implicitly has an 'any' type.
      this.setState(({ uploads }) => ({
        uploads: [...uploads, { file, inProgress: true, progress: 0 }],
      }));
    }
  };

  onProgress = (percent: number, status: string, file: FileWithStart) => {
    file.startTime = file.startTime || Date.now();
    // @ts-expect-error - TS7031 - Binding element 'uploads' implicitly has an 'any' type.
    this.setState(({ uploads }) => ({
      uploads: updateFile(uploads, file, { progress: percent }),
    }));
  };

  onFinish = (
    s3Object: {
      key: string;
    },
    file: FileWithStart
  ) => {
    const uploadDuration = Date.now() - file.startTime;
    const timeRemaining = Math.max(MIN_UPLOAD_DURATION - uploadDuration, 0);
    const newUpload = { file, key: s3Object.key } as const;

    setTimeout(() => {
      this.setState(
        // @ts-expect-error - TS7031 - Binding element 'uploads' implicitly has an 'any' type.
        ({ uploads }) => ({
          // @ts-expect-error - TS7006 - Parameter 'upload' implicitly has an 'any' type.
          uploads: uploads.map((upload) =>
            upload.file.name === file.name ? newUpload : upload
          ),
        }),
        () => {
          this.props.onFileFinished(newUpload);
          this.clearInput();
        }
      );
    }, timeRemaining);
  };

  onError = (error: string, file: File) => {
    // @ts-expect-error - TS7031 - Binding element 'uploads' implicitly has an 'any' type.
    this.setState(({ uploads }) => ({
      // @ts-expect-error - TS7006 - Parameter 'u' implicitly has an 'any' type.
      uploads: uploads.filter((u) => u.file.name !== file.name),
    }));
    this.clearInput();
    this.props.showFlashErrors &&
      showResponseFlashMessages(
        getErrorResponse(`${file.name} failed to upload: ${error}`)
      );
  };

  onRemoveFile = (upload: Upload) => {
    this.setState(
      // @ts-expect-error - TS7031 - Binding element 'uploads' implicitly has an 'any' type. | TS7031 - Binding element 'removedUploads' implicitly has an 'any' type.
      ({ uploads, removedUploads }) => ({
        // @ts-expect-error - TS7006 - Parameter 'u' implicitly has an 'any' type.
        uploads: uploads.filter((u) => u.key !== upload.key),
        removedUploads: [...removedUploads, upload],
      }),
      this.props.onFileRemoved(upload)
    );
  };

  // This needs to happen to allow the input to receive the same file
  // multiple times: https://github.com/odysseyscience/react-s3-uploader/issues/168
  clearInput = () => {
    this.uploadInput.value = null;
  };

  render() {
    const anyInProgress = this.state.uploads.some(
      // @ts-expect-error - TS2339 - Property 'inProgress' does not exist on type 'never'.
      (upload) => upload.inProgress
    );
    const maxFilesReached =
      !this.props.multiple && this.state.uploads.length > 0;
    const showAttachButton = !anyInProgress && !maxFilesReached;

    return (
      <Container>
        <ul>
          {this.state.uploads.map((upload) =>
            // @ts-expect-error - TS2339 - Property 'inProgress' does not exist on type 'never'.
            upload.inProgress ? (
              // @ts-expect-error - TS2339 - Property 'file' does not exist on type 'never'.
              <Uploading key={upload.file.name}>
                <UploadingText>{t('uploading')}</UploadingText>
                <Line
                  // @ts-expect-error - TS2339 - Property 'progress' does not exist on type 'never'.
                  percent={upload.progress}
                  trailWidth="3"
                  strokeWidth="3"
                  strokeColor={colors.mediumBlue}
                />
              </Uploading>
            ) : (
              // @ts-expect-error - TS2339 - Property 'file' does not exist on type 'never'.
              <li key={upload.file.name}>
                <StyledEditableRow
                  item={upload}
                  icon={<StyledFileIcon />}
                  maxLength={175}
                  draggable={false}
                  onRemoveRowClick={this.onRemoveFile}
                  removable
                >
                  {/* @ts-expect-error - TS2339 - Property 'file' does not exist on type 'never'. */}
                  {upload.file.name}
                </StyledEditableRow>
              </li>
            )
          )}
        </ul>

        {showAttachButton && (
          <ProxyFileInput
            htmlFor={this.props.id}
            // @ts-expect-error - TS2769 - No overload matches this call.
            tabIndex="0"
            onKeyUp={clickOnKeyUp}
          >
            <UploadButton block>
              {this.props.children || (
                <span>
                  <StyledPaperclipWrapper>
                    <PaperclipIcon />
                  </StyledPaperclipWrapper>
                  <ButtonText>
                    Attach File
                    {this.props.multiple ? 's' : ''}
                  </ButtonText>
                </span>
              )}
            </UploadButton>
          </ProxyFileInput>
        )}

        <SneakyInput
          id={this.props.id}
          multiple={this.props.multiple}
          accept={this.props.acceptedMimeTypes.join()}
          signingUrl={this.props.signingUrl}
          preprocess={this.preprocess}
          onProgress={this.onProgress}
          onError={this.onError}
          onFinish={this.onFinish}
          onChange={this.props.onChange}
          uploadRequestHeaders={{}}
          // @ts-expect-error - TS7006 - Parameter 'cmp' implicitly has an 'any' type.
          inputRef={(cmp) => (this.uploadInput = cmp)}
          autoUpload={this.props.autoUpload}
          disabled={this.props.disabled}
        />
      </Container>
    );
  }
}

const StyledEditableRow = styled(EditableRow)`
  p {
    font-weight: 400;
  }
  border-radius: 3px;
`;

const StyledFileIcon = styled(FileIcon)`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;

const StyledPaperclipWrapper = styled.span`
  margin-right: 10px;
  float: left;
  width: 20px;
  width: 20px;
`;

const ButtonText = styled.span`
  float: left;
  padding: 2px 0;
`;

const Container = styled.div`
  width: 100%;
`;

const Uploading = styled.div`
  width: 224px;
`;

const UploadingText = styled.div`
  color: ${colors.mediumGrey};
  font-size: 12px;
  letter-spacing: 0.2px;
  line-height: normal;
`;

// this will be the label that acts as a proxy for the real file input
// an approximation of most browsers outline when
// focused via tabbing
const blueOutline = '#5E9ED6';

/**
 * Real HTML file inputs cannot be styled well.
 *
 * To get around this, A label is created that sends a click event to the
 * real HTML file input (one that is hidden from view) so that it behaves
 * like a regular file input.
 * */
const ProxyFileInput = styled.label`
  display: inline-block;
  margin: 0 auto;
  cursor: pointer;

  &:focus {
    outline: 1px dotted ${blueOutline};
    outline: 5px auto -webkit-focus-ring-color;
  }
`;

const SneakyInput = styled(ReactS3Uploader)`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const UploadButton = styled(Button)<ButtonProps>`
  pointer-events: none;
  overflow-wrap: break-word;
  padding: 8px 12px 8px 10px;
  width: unset;
  ${/* @ts-expect-error polished */ ''}
  ${clearFix()} &:hover {
    color: unset;
  }
`;
